@let container = containerSg();

<div class="atn-mosaic-grid-container">
  <atn-mosaic-grid-element [element]="container.root" />
</div>
